import CoverFlow from "./index.vue"

export default CoverFlow